const _dreLancamento = {
  ENTRADAS: 1,
  DESPESAS_FIXAS: 2,
  SALARIOS_TREINADORES: 3,
  SALARIOS_ADM: 4,
  DESPESAS_VARIAVEIS: 5,
};

export default _dreLancamento;
